import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, H1Text, LeftBackButtonText, Hr, Text, Img, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { axiosLoginInstance, BASE_URLS } from "../../api";
import { TOKENS, AUTH_CHALLENGES } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import OTP from "../../components/otp";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import ArrowIcon from "../../assets/imgs/forwardarrow.svg";
import OpenIcon from "../../assets/imgs/eyeopen.svg";
import HiddenIcon from "../../assets/imgs/eyeclose.svg";

type Props = {
    history: {
        push: Function,
    },
}

const TemporaryPassword = (props: Props) => {
    const { location } = props;
    const [errorMessage, setErrorMessage] = useState();
    const [readOnly, setReadOnly] = useState([]);
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const history = useHistory();
    const [errorText, setErrorText] = useState('');
    const publicKey = localStorage.getItem('publicKey');
    const [showPassword, setShowPassword] = useState(false);
    const [showOTP, setShowOTP] = useState(false);
    const [otpDetail, setOtpDetail] = useState({
        userEmail: '',
        session: '',
        hint: '',
        authSuccessCallback: () => {},
    });


    useEffect(() => {
        if (history.location.state && history.location.state.errorMsg) {
            setErrorText(history.location.state.errorMsg);
        }
    }, []);

    const { handleSubmit, errors, control } = useForm();
    const onSubmit = async (data) => {
        const params = {
            email: `${localStorage.getItem('email')}`,
            password: data.password,
        };
        try {
            const { data: { entity } } = await axiosLoginInstance.post(`${BASE_URLS.AUTHENTICATE}`, params);
            const authSuccessCallback = async (authEntity) => {
                localStorage.setItem(TOKENS.SESSION_TOKEN, authEntity.session);
                setSuccess(true);
            };
            if (entity.challengeName === AUTH_CHALLENGES.CUSTOM_CHALLENGE) {
                setShowOTP(true);
                setOtpDetail({
                    userEmail: entity.challengeParameters?.email,
                    session: entity.session,
                    hint: entity.challengeParameters?.hint,
                    authSuccessCallback,
                });
            } else if (entity) {
                await authSuccessCallback(entity);
            }
        } catch (e) {
            setErrorText('');
            setShowErrorMessage(true);
            if (e && e.data && e.data.responseCode === 401) {
                setErrorMessage('Please make sure your email and password are valid');
            } else {
                setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
            }            
        }
    }

    useEffect(() => {
        if (success) {
            props.history.replace('/setuppassword');
        }
    }, [success]);

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => {props.history.push(`/connect/create?key=${btoa(publicKey)}`);}}
                        >
                            Back
                      </LeftBackButtonText>
                        <H1Text>
                            Configure Payments
                      </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                {
                    !showOTP && (
                        <FlexContainer
                            className="pt-3 pt-lg-5"
                            box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                            display="flow-root"
                        >
                            <H1Text className="px-1 px-md-4 mt-4">
                                ACCOUNT SETUP
                            </H1Text>
                            <Text className="px-1 px-md-4" paddingBottom="8px">
                                Enter the temporary password we sent to your email
                            </Text>
                            <Text className="px-1 px-md-4" paddingBottom="8px" fontWeight="600">
                                {`${localStorage.getItem('email')}`}
                            </Text>
                            <Hr />
                            <div className="px-1 px-md-4 mt-2">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <LabelText className="mt-4 mb-2">
                                        Temporary Password
                                </LabelText>
                                <InputWrapper marginBottom="0px" borderRadius="4px" width='298px'>
                                    <Controller
                                        defaultValue={""}
                                        control={control}
                                        color={errors.password ? "red" : "inherit"}
                                        border="0px !important"
                                        name="password"
                                        placeholder="Enter your Password"
                                        rules={{
                                            required: 'Password is required'
                                        }}
                                        as={<Input style={{
                                            marginTop: "0",
                                            marginBottom: "0px",
                                            width: "268px",
                                        }}
                                        type={showPassword ? "text" : "password"} readOnly={readOnly && readOnly.includes("password")} />}
                                    />
                                    <Img verticalAlign='middle' onClick={() => setShowPassword(!showPassword)} src={showPassword ? OpenIcon : HiddenIcon} />
                                    </InputWrapper>
                                    <ErrorMessage
                                        errors={errors}
                                        name="password"
                                        render={({ message }) => (
                                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                        )}
                                    />
                                    <div>
                                        <SubmitButton
                                            style={{ width: '292px' }}
                                            type="submit"
                                        >Next <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                    </div>
                                    {showerrorMessage && <PaymentError header={errorText ? errorText : errorMessage} message={null} />}
                                </form>
                            </div>
                        </FlexContainer>
                    )
                }
                {
                    showOTP && (
                        <FlexContainer
                            className="pt-3 pt-lg-5"
                            box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                            display="flow-root"
                        >
                            <OTP
                                isMobileView={false}
                                userEmail={otpDetail.userEmail}
                                firstHint={otpDetail.hint}
                                firstSession={otpDetail.session}
                                setShowOTP={setShowOTP}
                                authSuccessCallback={otpDetail.authSuccessCallback}
                            />
                        </FlexContainer>
                    )
                }
            </>
        } />
    )
};

export default TemporaryPassword;
